import React, { FC, useEffect, useState } from "react";
import Heading from "shared/Heading/Heading";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface HeaderFilterProps {
  tabActive: string;
  tabs: string[];
  heading: ReactNode;
  subHeading?: ReactNode;
  onClickTab?: (item: string) => void;
}

const HeaderFilter: FC<HeaderFilterProps> = ({
  tabActive,
  tabs,
  subHeading = "",
  heading = "🎈 Latest Articles",
  onClickTab,
}) => {
  const navigate = useNavigate();
  const [tabActiveState, setTabActiveState] = useState(tabActive);
  useEffect(() => {
    setTabActiveState(tabActive);
  }, [tabActive]);

  const handleClickTab = (item: string) => {
    onClickTab && onClickTab(item);
    setTabActiveState(item);
  };

  return (
    <div className="flex flex-col mb-8 relative">
      <div className="flex items-center justify-between">
        <Heading>{heading}</Heading>

        <span className="hidden sm:block flex-shrink-0">
          <ButtonPrimary
            className="!leading-none rounded-md"
            onClick={() => navigate("/vehicles")}
          >
            <span>View all</span>
            <i className="ml-3 las la-arrow-right text-xl"></i>
          </ButtonPrimary>
        </span>
      </div>
    </div>
  );
};

export default HeaderFilter;
